import { ConfigurationFilesResponse, File } from "./types";

export function filesMapper({ baseConfigurations, customConfigurations }: ConfigurationFilesResponse): Array<File> {
  return [
    ...baseConfigurations.map(fileName => ({ fileName, isBase: true })),
    ...customConfigurations.map(fileName => ({ fileName, isBase: false })),
  ]
}

export function getFileNameFromContentDisposition(header: string | undefined, fallback: string) {
  return header?.match(/filename="?([^";]+)"?/)?.[1] ?? fallback
}

export function saveFile(blob: Blob, fileName: string) {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = fileName
  link.click()

  window.URL.revokeObjectURL(url)
}
